<template>
  <div class="footer-container">
    <img
      class="footer-back"
      :src="require('../../assets/imgs/icon/footer-back.png')"
      @click="this.onBack"
    />
     <!-- 收藏按钮 无 -->
    <div class="home-button" @click="this.onButtonClick" >{{this.text}} </div>
  </div>
</template>

<script>
  import lottie from 'vue-lottie'
  import Anim from '../../assets/lottie/lottie-collect.json'
export default {
  name: "MoreFooter",
  data() {
    return {
      defaultOptions: {animationData: Anim, loop: true, autoplay: false},
      defaultAnim: '',
    }
  },
  props: {
    text: {
      type: String,
      default: '',
    },
    onBack:{
        type: Function,
        default: ()=>{},
    },
    onButtonClick:{
        type: Function,
        default: ()=>{},
    },
    onClickCollect:{
        type: Function,
        default: ()=>{},
    },
    onClickCancelCollect:{
        type: Function,
        default: ()=>{},
    },
    isFavorite:{
      type: Boolean,
      default: false
    },
    showCollect: {
      type: Number,
      default: 1
    }
  },
  methods: {
    // onBack() {
    //   location.href = "/home";
    // },
    // onButtonClick() {},
  },
  components: {
    lottie
  }
};
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
.footer-container {
  position: fixed;
  bottom: 0;
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.15);
  height: 62px;
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: center;
}

.footer-back {
  width: 62px;
  height: 62px;
}

.home-button {
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  margin: 0 20px;
  width: 100%;
  border-radius: 16px;
  background: linear-gradient(right, #98CEFF, #3994E7);
}
</style>


// WEBPACK FOOTER //
// app/components/footer/MoreFooter.vue